export enum ScreenUpload {
  CADASTRO_CARGA = 1,
  CADASTRO_SLA,
}
